import { combineReducers } from 'redux';
import CrudReducerService from '../utils/ReduxCrudBuilder/CrudReducerService';
import AccountReducer from './AccountReducer';
import EnrollmentReducer from './EnrollmentReducer';
import NotificationReducer from './NotificationReducer';
import PackageReducer from './PackageReducer';
import CartReducer from './CartReducer';
import SummaryReducer from './SummaryReducer';
import DivisionsReducer from './DivisionReducer';
import BeneficiaryReducer from './BeneficiaryReducer';
import SideNavReducer from './SideNavReducer';
import ModalReducer from './ModalReducer';
import HarmonyReducer from './HarmonyReducer';

const wolfPacApp = combineReducers({
    account: AccountReducer,
    employeeDependents: new CrudReducerService("EmployeeDependent", "EmployeeDependents").getReducer,
    employees: new CrudReducerService("Employee", "Employees").getReducer,
    enrollment: EnrollmentReducer,
    notifications: NotificationReducer,
    packages: PackageReducer,
    cart: CartReducer,
    summary: SummaryReducer,
    divisions: DivisionsReducer,
    beneficiaries: BeneficiaryReducer,
    sideNav: SideNavReducer,
    modals: ModalReducer,
    harmony: HarmonyReducer
});

export default wolfPacApp;